import React from 'react';
import { motion } from 'framer-motion';
import { modulos } from '../data/content';
export function ModulesSection() {
  return <section className="w-full bg-background px-5 py-12 sm:py-20" data-id="element-145" data-mp="1ntwam8l2b767">
      <div className="mx-auto max-w-5xl" data-id="element-146" data-mp="1iv1rf5j6nglk">
        <div className="mx-auto max-w-2xl text-center" data-id="element-147" data-mp="1iw31p7sdjz28">
          <h2 className="font-display text-2xl font-bold leading-tight text-foreground sm:text-4xl" data-id="element-148" data-mp="1dx094mtkzlb5">
            6 Módulos <span className="text-pink" data-id="element-149" data-mp="2bkiedno1a5ae">paso a paso</span>
          </h2>
          <p className="mt-3 text-sm text-muted sm:text-base" data-id="element-150" data-mp="26lfai6jsi540">
            Todo lo que necesitás, en el orden correcto.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-3 min-[480px]:gap-4 sm:gap-6 md:grid-cols-2" data-id="element-151" data-mp="21khu9zicbl55">
          {modulos.map((modulo, i) => <motion.article key={modulo.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.45,
          delay: i % 2 * 0.08
        }} className="flex gap-3 rounded-2xl border border-line bg-surface p-4 shadow-card min-[480px]:gap-5 min-[480px]:p-6 sm:gap-6 sm:p-7" data-id="element-152" data-mp="1wp2idd3w7zbd" data-mpi={i}>
              <div className="flex min-w-0 flex-1 flex-col" data-id="element-153" data-mp="18w136gyvui34">
                <span className="font-display text-3xl font-bold leading-none text-primary sm:text-4xl" data-id="element-154" data-mp="1dw5m0dn9jowi">
                  {modulo.number}
                </span>
                <h3 className="mt-3 text-base font-bold leading-snug text-foreground sm:text-lg" data-id="element-155" data-mp="10369mkis2at6">
                  {modulo.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-muted" data-id="element-156" data-mp="q6tbnag79asm">
                  {modulo.description}
                </p>
                <span className="mt-5 inline-block w-fit rounded-full bg-primary/10 px-3 py-1 text-xs font-medium text-primary-strong" data-id="element-157" data-mp="v6fp9kzxwt1y">
                  {modulo.tag}
                </span>
              </div>
              <img src={modulo.coverImage} alt={`Módulo ${modulo.number}: ${modulo.title} – Aprende Coreano Fácil`} width="480" height="640" loading="lazy" decoding="async" className="block aspect-[3/4] w-[32%] shrink-0 self-start rounded-xl object-cover shadow-mockup min-[480px]:w-[140px]" data-id="element-158" data-mp="l6yl580c6n83" />
            </motion.article>)}
        </div>
      </div>
    </section>;
}